import { render } from "./NuevoContacto.vue?vue&type=template&id=3994b634"
import script from "./NuevoContacto.vue?vue&type=script&lang=js"
export * from "./NuevoContacto.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__